module.exports = __webpack_public_path__ + "static/media/Autometic-meter-reading.2d97ba35.jpg";